module.exports = Object.freeze({
  CELSIUS: "C",
  FAHRENHEIT: "F",
});
